'use strict';

angular.module('ClinicApp').directive('profileName', function(ClinicService, DoctorService, CurrentUser) {
  return {
    scope: {
      profile: '=profileName',
      modelType: '=',
    },
    templateUrl: '/views/directives/_profile-name.html',
    link: function($scope) {
      if (['clinic', 'doctor'].indexOf($scope.modelType) == -1) {
        throw new Error('DirectiveArgumentError: `profileSettings` invalid modelType: ' + $scope.modelType + '.');
      }
      $scope.formattedModelType = $scope.modelType == 'clinic' ? 'practice' : 'provider';

      $scope.checkName = function(name) {
        if (!name || name.length === 0) {
          return 'Name is required.';
        }
      };

      $scope.updateName = function() {
        let promise = null;

        if ($scope.modelType === 'clinic') {
          promise = ClinicService.updateClinic($scope.profile, {
            name: $scope.profile.name,
          });
        } else {
          promise = DoctorService.updateDoctor($scope.profile, {
            name: $scope.profile.name,
          });
        }

        promise.then(function() {
          CurrentUser.update(); // update the navigation bar.
          $scope.$emit('reloadDoctor');
          $scope.$emit('reloadClinic');
        });
      };
    },
  };
});
